<template>
  <div>
    <template v-if="loading">
      <div
        class="d-flex vertical-center justify-content-center align-items-center"
        style="height: 50vh; display: flex"
      >
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CModal
        title="Test has been closed."
        centered
        color="light"
        :show.sync="adminLockTestModal"
        :closeOnBackdrop="false"
      >
        <h5>Contact the instructor of your section and try again later.</h5>
        <br />
      </CModal>
      <div class="CIT_background">
        <div class="position" style="display: flex; flex-direction: column">
          <div class="container_CIT02">
            <div class="block">
              <Card :imgUrl="baseUrl + content" />
            </div>
            <div class="btn-exit">
              <ButtonIcon
                :bgColor="`#ed8e91`"
                :iconUrl="'close.png'"
                :size="1"
                :url_image="false"
                @click="onClose(navigate.close.action)"
              />
            </div>
          </div>
          <CRow
            style="
              display: flex;
              justify-content: center;
              margin: 0;
              padding: 0;
            "
          >
            <div
              class="button button_setting"
              @click="onNextRoute(navigate.next.action)"
            >
              <CCol col="8">
                <div class="font_size">START</div>
              </CCol>
              <CCol col="2">
                <i class="fas fa-caret-right fa-5x" style=""></i>
              </CCol>
            </div>
          </CRow>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ButtonIcon from '@/components/elements/Buttons/ButtonIcon';
import Card from '@/components/elements/Card';
import LoadingMDL from '@/components/loading/LoadingMDL';
import {mapGetters} from 'vuex';

export default {
  components: {ButtonIcon, Card, LoadingMDL},
  name: 'CIT02',
  props: {},
  data() {
    return {
      content: [],
      loading: true,
      baseUrl: process.env.VUE_APP_URL_SOUND,
      navigate: [],
      templateData: {},
      startTime: this.$helpers.getDateFormat(),
      condition: [],
      code: '',
      section: '',
      v3Data: null,
      adminLockTestModal: false,
      nextRouteCodeItem: null,
    };
  },
  methods: {
    onNextRoute: function (route) {
      //checking Lock Test Here !
      const urlStr = this.content;
      if (urlStr == '/chinese2/Picture/ICON%20TEST.png') {
        const lessonCodeItem = this.$store.state.v3.lessonCode;

        const payload = {
          courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
          section: this.$store.state.v3.v3EnrollData.data.section,
          codeItem: `${lessonCodeItem}`,
        };

        this.$store.dispatch('v3-data/v3LessonLockStatus', payload);

        //add nextRoute
        this.nextRouteCodeItem = route;
      } else {
        //if not test operate normally
        this.loading = true;
        // // ส่วนนี้เป็นส่วนของการบันทึกข้อมูลไปยัง DB โดยส่งข้อมูลไปยัง backend ในรูปแบบนี้โดยไม่ต้องรอค่ารีเทิร์น
        const data = [
          {
            codeItem: this.v3Data.codeItem,
            courseId: this.$store.state.necessary.learningCourse,
            template: this.v3Data.templateID,
            section: this.$store.state.v3.v3EnrollData.data.section,
            content: this.v3Data.content,
            type: this.v3Data.type,
            answering: [], // ถ้าหน้าไหนมีแบบฝึกหัดให้เพิ่มส่วนนี้มาด้วย (ต้องอ้างอิงฟอร์มข้ออันเดิม)
            progress: 100,
            score: 0,
            maxScore: 0,
          },
        ];

        this.$store.dispatch('v3/saveContent', data);
        // //===========================================================

        this.$store.commit('v3/stampMainCodeItem', route); // บันทึกข้อมูลตัวแม่ของชุดข้อมูล
        const str = route.split('-');
        const path = `/v3/${str[0]}/${str[1]}`;
        this.$router.push(path);
      }
    },
    onClose: function (route) {
      const str = route.split('-');
      const path = `/v3/${str[0]}/${str[1]}`;
      this.$router.push(path);
    },
  },
  computed: {
    ...mapGetters({
      getTemplateAndProgress: 'template/getTemplateAndProgress',
      getTemplatev3: 'v3/getTemplates',
      v3LessonLockStatus: 'v3-data/v3LessonLockStatus',
    }),
  },
  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      const template = val.templates[0];
      this.content = template.content.image;
      this.navigate = template.navigate;

      this.loading = false;
    },

    v3LessonLockStatus: function (val) {
      //check Test status before redirect
      if (val.isLock) {
        //if isLock true
        //alert cannot do test since is locking
        this.adminLockTestModal = true;
      } else {
        //isLock is false
        //operate normally
        this.loading = true;
        // // ส่วนนี้เป็นส่วนของการบันทึกข้อมูลไปยัง DB โดยส่งข้อมูลไปยัง backend ในรูปแบบนี้โดยไม่ต้องรอค่ารีเทิร์น
        const data = [
          {
            codeItem: this.v3Data.codeItem,
            courseId: this.$store.state.necessary.learningCourse,
            template: this.v3Data.templateID,
            section: this.$store.state.v3.v3EnrollData.data.section,
            content: this.v3Data.content,
            type: this.v3Data.type,
            answering: [], // ถ้าหน้าไหนมีแบบฝึกหัดให้เพิ่มส่วนนี้มาด้วย (ต้องอ้างอิงฟอร์มข้ออันเดิม)
            progress: 100,
            score: 0,
            maxScore: 0,
          },
        ];

        this.$store.dispatch('v3/saveContent', data);
        // //===========================================================

        this.$store.commit('v3/stampMainCodeItem', this.nextRouteCodeItem); // บันทึกข้อมูลตัวแม่ของชุดข้อมูล
        const str = this.nextRouteCodeItem.split('-');
        const path = `/v3/${str[0]}/${str[1]}`;
        this.$router.push(path);
      }
    },
  },
  created() {
    this.currentRoute = this.$route.name + '-' + this.$route.params.id;
    this.courseData = this.$store.getters['necessary/getLerningCourse'];
    this.code = this.courseData._id;
    this.section = this.$store.getters['necessary/getUserCourseSection'];
  },
  mounted() {
    this.$store.dispatch('v3/fetchTemplateByCode', this.currentRoute);
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
.CIT_background {
  background-color: #ffdc77;
}

.position {
  margin-top: 3%;
  display: flex;
  align-content: center;
  justify-content: center;
}

.block {
  width: 450px;
  height: 450px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 20px;
}

.card {
  width: 400px;
  height: 400px;
  background-color: white;
  border-radius: 20px;
  /* 5px rounded corners */
  border: 0px solid;
}

.btn-exit {
  right: 34%;
  position: absolute;
  width: 60px;
  height: 60px;
  // margin-left: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.container_CIT02 {
  margin-top: 10%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.button_setting {
  background-color: #f1b205;
  color: white;
  text-align: center;
  text-decoration: none;
  font-size: 12px;
  border-radius: 10px !important;
  box-shadow: none;
  margin-top: 6%;
  margin-bottom: 5%;
  width: 250px;
  height: 70px;
}

.font_size {
  font-size: 18px;
}

// resolution mobile
@media screen and (min-width: 300px) and (max-width: 600px) {
  .position {
    padding-top: 20%;
    padding-bottom: 20%;
  }

  .container_CIT02 {
    margin-top: 20%;
  }

  .block {
    margin-top: 20px;
    width: 250px;
    height: 250px;
  }

  .card {
    width: 250px;
    height: 250px;
  }

  .button_setting {
    width: 150px;
    height: 50px;
  }

  .fa-caret-right {
    font-size: 30px;
  }

  .font_size {
    font-size: 12px;
  }

  .btn-exit {
    width: 70px;
    height: 70px;
    padding: 10px;
    right: -1%;
    font-size: 30px;
  }
}

// resolution ipad
@media only screen and (min-width: 700px) and (max-width: 821px) {
  .btn-exit {
    width: 60px;
    height: 60px;
    right: 10%;
  }
}

// resolution ipad pro
@media only screen and (min-width: 1024px) and (max-width: 1025px) {
  .btn-exit {
    width: 60px;
    height: 60px;
    right: 20%;
  }

  .position {
    margin-top: 0;
  }
}

@media only screen and (min-width: 1030px) and (max-width: 1366px) {
  .btn-exit {
    right: 22%;
  }
}

// PC MAX 1800
@media only screen and (min-width: 1366px) and (max-width: 1600px) {
  .btn-exit {
    width: 60px;
    height: 60px;
    right: 32%;
  }

  .position {
    margin-top: 0;
  }

  .button_setting {
    margin-top: 5%;
  }
}

// PC MAX 1600
@media only screen and (min-width: 1366px) and (max-width: 1600px) {
  .btn-exit {
    width: 60px;
    height: 60px;
    right: 28%;
  }
}

// PC MAX 1400
@media only screen and (min-width: 1367px) and (max-width: 1400px) {
  .btn-exit {
    width: 60px;
    height: 60px;
    right: 28%;
  }
}
</style>
